/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CatalogsOrganizationCatalogIdProductsProductIdPutRequest
 */
export interface CatalogsOrganizationCatalogIdProductsProductIdPutRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CatalogsOrganizationCatalogIdProductsProductIdPutRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogsOrganizationCatalogIdProductsProductIdPutRequest
     */
    price?: number;
}

/**
 * Check if a given object implements the CatalogsOrganizationCatalogIdProductsProductIdPutRequest interface.
 */
export function instanceOfCatalogsOrganizationCatalogIdProductsProductIdPutRequest(value: object): value is CatalogsOrganizationCatalogIdProductsProductIdPutRequest {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function CatalogsOrganizationCatalogIdProductsProductIdPutRequestFromJSON(json: any): CatalogsOrganizationCatalogIdProductsProductIdPutRequest {
    return CatalogsOrganizationCatalogIdProductsProductIdPutRequestFromJSONTyped(json, false);
}

export function CatalogsOrganizationCatalogIdProductsProductIdPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogsOrganizationCatalogIdProductsProductIdPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function CatalogsOrganizationCatalogIdProductsProductIdPutRequestToJSON(json: any): CatalogsOrganizationCatalogIdProductsProductIdPutRequest {
    return CatalogsOrganizationCatalogIdProductsProductIdPutRequestToJSONTyped(json, false);
}

export function CatalogsOrganizationCatalogIdProductsProductIdPutRequestToJSONTyped(value?: CatalogsOrganizationCatalogIdProductsProductIdPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'price': value['price'],
    };
}

